/**
 *
 * PickupTimeTripBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PickupIcon from '../../../../assets/v2/PickupIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.majorelleBlueDark};
    background: ${COLORS.majorelleBlueLight};
    border-color: ${COLORS.majorelleBlue};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.majorelleBlue};
    }
  }
`;

function PickupTimeTripBadge(props) {
  return (
    <StyledBadge
      icon={<PickupIcon />}
      size="iconLarge"
      variant="outlined"
      {...props}
    />
  );
}

export default memo(PickupTimeTripBadge);
